import React from 'react';
import PropTypes from 'prop-types';
import {Header} from "semantic-ui-react";
import {FormattedMessage} from 'react-intl';

import {formatKilobytes} from "utils/DBUtils";
import ImageButtons from "./ImageButtons";
import ItemInfoGroup from "../common/ItemInfoGroup";
import ImageUploaderAccordionPagingBar from 'components/images/ImageUploaderAccordionPagingBar';

const ImageUploaderAccordion = (props) => (
    <section>
        <Header as='h5'>
            <FormattedMessage id="editbreak.image_upload.header"/>
        </Header>
        <p>
            <FormattedMessage id="editbreak.image_upload.file_types_allowed"/>
        </p>

        <ImageButtons disabled={props.isUploading}
                      onBrowse={props.onBrowse}
                      allowIdInput={false}/>

        <ItemInfoGroup onHeaderClick={(image) => props.onImageClicked(image.id)}
                       onRemoveClick={props.onRemoveButtonClicked}
                       items={props.images}
                       itemDetails={props.images.map((item) => ({
                           header: item.name || item.filename || "{No Name}",
                           description: `Type: ${item.contentType || "Unknown"} | Size: ${formatKilobytes(item.size) || "Unknown"}`
                       }))}/>

       <ImageUploaderAccordionPagingBar />
    </section>
);

ImageUploaderAccordion.propTypes = {
    images: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.string.isRequired,
        name: PropTypes.string,
        filename: PropTypes.string,
        contentType: PropTypes.string,
        size: PropTypes.number
    })),
    onImageClicked: PropTypes.func.isRequired,
    onBrowse: PropTypes.func.isRequired,
    onRemoveButtonClicked: PropTypes.func.isRequired
};

ImageUploaderAccordion.defaultProps = {
    images: []
};

export default ImageUploaderAccordion;



// WEBPACK FOOTER //
// ./public/components/images/ImageUploaderAccordion.jsx